module.exports = __webpack_public_path__ + "img/claim.020cf76d.svg";